import { render, staticRenderFns } from "./quickshopping.vue?vue&type=template&id=0a40c32b&scoped=true"
import script from "./quickshopping.vue?vue&type=script&lang=js"
export * from "./quickshopping.vue?vue&type=script&lang=js"
import style0 from "./quickshopping.vue?vue&type=style&index=0&id=0a40c32b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a40c32b",
  null
  
)

export default component.exports